import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';

// ✅ SAFE: This check ensures the code inside ONLY runs in a web browser
if (typeof document !== 'undefined') {
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    throw new Error("Could not find root element to mount to");
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>
  );

  // Signal for react-snap that app is ready
  document.dispatchEvent(new Event('app-mounted'));
}